import { render } from "./PageLoader.vue?vue&type=template&id=d3c545ee&scoped=true"
const script = {}

import "./PageLoader.vue?vue&type=style&index=0&id=d3c545ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c545ee"]])

export default __exports__